import { v4 as uuidv4 } from 'uuid'
import { canAccessWebLocalStorage } from '../assertion'

const STORAGE_PREFIX_KEYS = 'mote-auth-'
const ANONYMOUS_PREFIX = 'anonymous:from_website:'
const hasLocalStoragePermission = canAccessWebLocalStorage()

/**
 * @description It checks if any anonymous user id already exists in local storage,
 * If yes then return the existing value with creation time details else create a new one and return the details
 * @returns  {anonymousUserId:string, anonymousCreatedAt:string}
 */
export const getOrMakeAnonymousUserId = () => {
  // Keys for storing anonymous user id details in local storage
  const userIdKey = STORAGE_PREFIX_KEYS + 'anonymousUserId'
  const createdAtKey = STORAGE_PREFIX_KEYS + 'anonymousCreatedAt'

  // Check if anonymous user id is already in local storage if yes return the existing details
  if (hasLocalStoragePermission) {
    const userIdFromLocalStorage = window.localStorage.getItem(userIdKey)
    if (userIdFromLocalStorage) {
      const createdAtFromLocalStorage =
        window.localStorage.getItem(createdAtKey)
      return {
        anonymousUserId: userIdFromLocalStorage,
        anonymousCreatedAt: createdAtFromLocalStorage
      }
    }
  }

  // If anonymous user id is not available in local storage

  // Create random user id
  const anonymousUserId = ANONYMOUS_PREFIX + uuidv4()
  // Create created at details
  const anonymousCreatedAt = String(Math.floor(Date.now() / 1000))

  // Store random user id and created at details
  if (hasLocalStoragePermission) {
    window.localStorage.setItem(userIdKey, anonymousUserId)
    window.localStorage.setItem(createdAtKey, anonymousCreatedAt)
  }

  // Return the newly created anonymous user id
  return { anonymousUserId, anonymousCreatedAt }
}

export const getUserIdMaybeAnonymous = () => {
  let userId = null
  let anonymousUserId = null

  if (hasLocalStoragePermission) {
    userId = window.localStorage.getItem(STORAGE_PREFIX_KEYS + 'userId')
    anonymousUserId = window.localStorage.getItem(
      STORAGE_PREFIX_KEYS + 'anonymousUserId'
    )
  }

  if (userId) return userId

  if (!anonymousUserId) return getOrMakeAnonymousUserId()

  return anonymousUserId
}
